export default () => {
  $(".footer-links a").click(function(e) {
    if ($(this).text().toLowerCase() === "mis cookies" || $(this).text().toLowerCase() === "gestión de cookies") {
      if (typeof Didomi === "object") {
        Didomi.preferences.show();
      }
      e.preventDefault();
    }
  });
}
